// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n/* 字体 */\n/* Colors\n-------------------------- */\n/* 尺寸\n-------------------------- */\n.chart-content[data-v-044d1284] {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n.chart-content .chart-component[data-v-044d1284] {\n    width: 100%;\n    height: 100%;\n}\n.chart-content .charComHeight[data-v-044d1284] {\n    height: 120% !important;\n}\n", ""]);
// Exports
module.exports = exports;
